import React, { use } from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import ArrowRightAlt from '@mui/icons-material/ArrowRightAlt';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

export const CTASection = () => {
  const theme = useTheme();
  const isMobile = theme.breakpoints.down('sm');
  const navigate = useNavigate();
  return (
    <Box sx={{ py: 10, px: 2, position: 'relative', zIndex: 10, overflow: 'hidden' }}>
      <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <Box
            sx={{
              borderRadius: 4,
              overflow: 'hidden',
              position: 'relative',
              background: 'linear-gradient(135deg, #6a1bff 0%, #00e5ff 100%)',
              backgroundSize: '200% 200%',
              animation: 'gradientAnimation 5s ease infinite',
              '@keyframes gradientAnimation': {
                '0%': { backgroundPosition: '0% 50%' },
                '50%': { backgroundPosition: '100% 50%' },
                '100%': { backgroundPosition: '0% 50%' }
              }
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                right: 0,
                opacity: 0.1
              }}
            >
              <svg width="300" height="300" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                <path fill="#FFFFFF" d="M39.9,-68.5C53.4,-62.9,67.3,-55.6,76.3,-43.8C85.3,-32,89.4,-16,88.1,-0.8C86.8,14.5,80.1,28.9,71.2,41.3C62.3,53.6,51.2,63.8,38.5,70.2C25.7,76.6,12.9,79.2,-0.7,80.3C-14.3,81.4,-28.5,81.1,-40.3,74.9C-52.1,68.7,-61.5,56.6,-69.3,43.4C-77.1,30.1,-83.3,15.1,-83.7,-0.2C-84.1,-15.5,-78.7,-31,-70.1,-44.4C-61.6,-57.7,-49.9,-68.9,-36.5,-74.6C-23,-80.3,-11.5,-80.6,1.1,-82.6C13.7,-84.6,27.5,-88.3,39.9,-85.4C52.4,-82.5,61.6,-73.1,71.5,-62.3C81.4,-51.5,92,-39.4,99.1,-25.4C106.3,-11.3,110,4.7,106.9,19.2C103.8,33.7,94,46.7,81.2,55.1C68.4,63.5,52.7,67.3,38.7,72C24.7,76.8,12.4,82.5,-0.5,83.5C-13.5,84.5,-27,80.7,-41,75.5C-55.1,70.3,-69.6,63.7,-79.6,52.2C-89.6,40.8,-95,24.4,-94.8,8.5C-94.7,-7.4,-88.9,-23.3,-80.2,-36.9C-71.4,-50.6,-59.6,-62,-45.8,-68.6C-32,-75.1,-16,-76.8,-0.9,-75.2C14.1,-73.7,28.3,-68.8,39.9,-68.5Z" transform="translate(100 100)" />
              </svg>
            </Box>
            <Box sx={{ p: { xs: 4, md: 8 }, position: 'relative', zIndex: 10 }}>
              <Box sx={{ maxWidth: 'md', mx: 'auto', textAlign: 'center', color: 'white' }}>
                <Typography variant="h3" gutterBottom sx={{ fontWeight: 700 }}>
                  Ready to Transform Your Business?
                </Typography>
                <Typography variant="h6" sx={{ opacity: 0.9, mb: 4, fontWeight: 400 }}>
                  Let's discuss how our tailored solutions can help you achieve your business goals.
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: 2,
                    justifyContent: 'center'
                  }}
                >

                  <Button
                    variant="contained"
                    size={isMobile ? 'large' : 'large'}
                    endIcon={<ArrowRightAlt />}
                    onClick={() => navigate('/contact')}
                    sx={{
                      px: 6,
                      py: 1.5,
                      fontSize: '1rem',
                      fontWeight: 600,
                      borderRadius: 2,
                      boxShadow: theme.shadows[4],
                      '&:hover': {
                        boxShadow: theme.shadows[8],
                      },
                      position: 'relative',
                      zIndex: 1,
                    }}
                  >
                    Get Started
                  </Button>
                  {/* <Button 
                    variant="contained" 
                    size="large"
                    sx={{ 
                      bgcolor: 'white', 
                      color: 'primary.main',
                      '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' },
                      fontWeight: 500
                    }}
                  >
                    Schedule Consultation
                  </Button> */}
                  {/* <Button 
                    variant="outlined" 
                    size="large"
                    sx={{ 
                      borderColor: 'white', 
                      color: 'white',
                      '&:hover': { 
                        bgcolor: 'rgba(255,255,255,0.1)',
                        borderColor: 'white' 
                      },
                      fontWeight: 500
                    }}
                  >
                    View Case Studies
                  </Button> */}
                </Box>
              </Box>
            </Box>
          </Box>
        </motion.div>
      </Box>
    </Box>
  );
};